<!--
 * @Author: zb
 * @LastEditors: 请在根目录下.vscode改成你的名字
 * @Date: 2019-08-08 19:37:57
 * @LastEditTime: 2019-09-27 10:41:25
 * @Version: 1.0
 * @Description: 被邀报价页面
 * @Company: 济南广域软件
 * @Copyright: Copyright (c) Jnwat Soft
 * @Remarks: 备注
 -->

<template>
  <div class="content-container">
    <!-- 查询表单  -->
    <div class="goods-head">
      <div class="goods-head-form">
        <div class="fileds">
          <el-form ref="form" :inline="true" :model="queryParams" label-width="100px">
            <el-form-item label="始发地" prop="startPlace">
              <el-cascader
                v-model="queryParams.startPlace"
                :options="area"
                :filterable="true"
                :props="{ expandTrigger: 'hover', checkStrictly: true }"
              />
            </el-form-item>
            <el-form-item label="目的地" prop="stopPlace">
              <el-cascader
                v-model="queryParams.stopPlace"
                :options="area"
                :filterable="true"
                :props="{ expandTrigger: 'hover', checkStrictly: true }"
              />
            </el-form-item>
            <el-form-item label="货物类型" prop="goodsType">
              <el-select v-model="queryParams.goodsType" placeholder="请选择">
                <el-option
                  v-for="(item,index) in goodsType"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
            <el-form-item v-inputFilter label="货物名称" prop="goodsName">
              <el-input v-model="queryParams.goodsName" placeholder="请输入" />
            </el-form-item>
          </el-form>
        </div>
        <div class="buttons">
          <el-button
            size="small"
            style="background-color: #BE2316;border-color: #F56C6C;"
            class="form-item-btn"
            type="primary"
            @click="loadData"
          >
            <i class="el-icon-search" />查询
          </el-button>
          <el-button
            size="small"
            style="background-color: #BE2316;border-color: #F56C6C;"
            class="form-item-btn"
            type="primary"
            @click="resetForm"
          >
            <i class="el-icon-delete-solid" />
            重置
          </el-button>
        </div>
      </div>
    </div>
    <div v-loading="viewManager.loading" class="goods-data">
      <div class="goods-data-header">
        <ul>
          <li>起始地/目的地</li>
          <li>货物名称</li>
          <li>发布时间</li>
          <li>货物重量</li>
          <li>公司名称</li>
          <li>操作</li>
        </ul>
      </div>
      <div ref="data-body" class="goods-data-body">
        <template v-if="data.length < 1 && !viewManager.loading">
          <div class="no-data-info">
            <font>暂无匹配数据</font>
          </div>
        </template>
        <template v-for="(goods, index) of data">
          <div :key="index" class="data-item">
            <ul>
              <li>{{ goods.startPlaceLabel }}一{{ goods.stopPlaceLabel }}</li>
              <li>{{ goods.goodsTypeLabel }}ᅳ{{ goods.goodsName }}</li>
              <li>{{ goods.createDate|_data }}</li>
              <li>{{ goods.weight }}</li>
              <li>{{ goods.companyName }}</li>
              <li>
                <template v-if="goods.offerType !== 0">
                  <el-button
                    style="width:5rem"
                    type="text"
                    :disabled="true"
                  > {{ goods.offerType == 1? '已报价' : '已拒绝报价' }}</el-button>
                  <el-divider direction="vertical" />
                </template>
                <template v-else-if="!isDisabledOffer(goods)">
                  <el-button
                    style="width:3rem"
                    type="text"
                    @click="quotation(goods)"
                  >同意</el-button>
                  <el-divider direction="vertical" />
                  <el-button
                    style="width:3rem"
                    type="text"
                    @click="rejectOffer(goods)"
                  >拒绝</el-button>
                </template>
                <template v-else>
                  <el-button
                    style="width:5rem"
                    type="text"
                    :disabled="true"
                  >已截止报价</el-button>
                </template>
                <el-button plain size="small" @click="showDetail(goods)">
                  详情
                  <i :class="{'expand': !goods.hidden}" class="el-icon-d-arrow-right" />
                </el-button>
              </li>
            </ul>
            <goodsFullInfo v-if="!goods.hidden" :goods="goods" :area="area" />
          </div>
        </template>
      </div>
      <div class="goods-data-pagination">
        <el-pagination
          :current-page="pagination.pageNo"
          :total="pagination.total"
          :page-size="pagination.pageSize"
          layout="prev, pager, next, jumper,total, sizes"
          @current-change="changeCurrent"
          @size-change="changeSize"
        />
      </div>
    </div>
    <!-- 报价对话框  -->
    <offer ref="offer-dialog" @done="loadData" />
  </div>
</template>

<script>
import mixinsFunction from '@/utils/mixinsFunction'
import goodsFullInfo from '@/views/personal/goods/components/goodsFullInfo'
import {
  getMyInvitation,
  goodsListData,
  updateExpectPrice
} from '@/api/personal/find/goodsManager'
import { Page } from '@/utils/commonDataModel'
import offer from '@/views/personal/transport/offer'

export default {
  name: 'InvitatedList',
  components: {
    goodsFullInfo,
    offer
  },
  mixins: [mixinsFunction],
  data: function() {
    return {
      // 表格数据
      pagination: new Page(),
      // 验证数据一致性
      queryParams: {},
      state: false,
      area: [],
      // 运输方式
      transportType: [],
      goodsType: [],
      data: []
    }
  },
  created: function() {
    if (this.$route.params.noticeId != undefined) {
      // console.log('消息通知过来的数据', 'id:' + this.$route.params.noticeId,
      //   'type:' + this.$route.params.noticeMark, 'data:' + this.$route.params.data)
      const oid = {
        id: this.$route.params.data.noticeModuleId
      }
      this.loadTableData(oid)
    } else {
      this.init()
    }
  },
  mounted() {
    document.onkeydown = (e) => {
      // console.log(e)
      if (e.keyCode === 13) {
        this.loadData()
      }
    }
  },
  methods: {
    isDisabledOffer(goods) {
      // 报价时间已经截止则不再报价
      if (goods.expireDate) {
        if (goods.expireDate instanceof Date) {
          return goods.expireDate.getTime() < Date.now() - Date.now() % (1000 * 60 * 60 * 24)
        } else {
          return Date.parse(goods.expireDate) < Date.now() - Date.now() % (1000 * 60 * 60 * 24)
        }
      }
      return false
    },
    // 拒绝报价
    rejectOffer(item) {
      const formParams = {}
      formParams.goodsId = item.id
      formParams.goodsCreateUser = item.createUser
      formParams.companyId = item.companyId
      formParams.weight = item.weight
      formParams.goodsTypeLabel = item.goodsTypeLabel
      formParams.companyName = item.companyName
      formParams.companyContact = item.contacter
      formParams.contactTel = item.contacterTel
      this.viewManager.loading = true
      this.$confirm('是否拒绝报价?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        updateExpectPrice(formParams).then(data => {
          this.$message({
            message: '已拒绝',
            type: 'success'
          })
          setTimeout(() => {
            this.viewManager.close()
          }, 500)
        }).catch(() => {
          // console.error(error)
        }).finally(() => {
          this.loadData()
          this.viewManager.loading = false
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        })
        this.loadData()
        this.viewManager.loading = false
      })
    },
    quotation(item) {
      this.$refs['offer-dialog'].open(item)
    },
    // 初始化函数
    async init() {
      await Promise.all([
        this.loadData(),
        this.getArea(),
        this.getGoodsType(),
        this.getTransportType()
      ]).then(data => {
        [, this.area, this.goodsType, this.transportType] = data
      })
      this.viewManager.loading = false
    },
    // 展示详情
    showDetail(goods) {
      // 当前是展开的只需关闭
      if (goods.hidden) {
        // 把展开的关闭
        this.data.forEach(item => {
          item.hidden = true
        })
      }
      goods.hidden = !goods.hidden
    },
    // 切换发布状态
    toggleState() {
      this.state = !this.state
    },
    // 重置表单并刷新
    resetForm() {
      this.$refs['form'].resetFields()
      this.loadData()
    },
    // 回到表格顶部
    scrollTop() {
      this.$el.scrollIntoView()
    },
    changeSize(size) {
      this.pagination.pageSize = size
      this.loadData()
    },
    changeCurrent(current) {
      this.pagination.pageNo = current
      this.loadData()
    },
    // 转换参数
    exchangeData(data) {
      const handle = {
        get(target, key, proxy) {
          if (
            (key == 'startPlace' || key === 'stopPlace') &&
            target[key] &&
            target[key].length > 0
          ) {
            return target[key] instanceof Object
              ? target[key].length === 1
                ? target[key].join('#')
                : target[key].join('#') + '#'
              : target[key]
          } else {
            return target[key]
          }
        }
      }
      if (window && window.Proxy) {
        const p = new Proxy(data, handle)
        const proxyData = Object.assign({}, p)
        return proxyData
      } else {
        const proxyData = {}
        for (const key in data) {
          proxyData[key] = handle.get(data, key)
        }
        return proxyData
      }
    },
    // 准备查询数据
    loadData() {
      this.loadTableData(this.exchangeData(this.queryParams))
    },
    // 加载货源数据
    loadTableData(params) {
      this.viewManager.loading = true
      getMyInvitation(this.pagination, params)
        .then(data => {
          this.data = data.result.rows.map(item => {
            if (!item.hasOwnProperty('hidden')) {
              item.hidden = true
            }
            if (item.fileUrl !== '') {
              item.fileUrl = String(item.fileUrl).split(',')
            }
            return item
          })
          this.pagination.total = data.result.total
        })
        .catch(() => {
          this.data = goodsListData.map(item => {
            if (!item.hasOwnProperty('hidden')) {
              item.hidden = true
            }
            return item
          })
          this.pagination.total = this.data.length
          // console.error(error)
        })
        .finally(() => {
          // 数据刷新时  全选状态为false
          this.scrollTop()
          this.viewManager.loading = false
        })
    }
  }
}
</script>
<style lang="scss" scoped>
$main-color: #be2316;

.content-container {
  box-sizing: border-box;
  margin-top: 1px;
  .goods-head {
    padding: 12px 12px;
    box-sizing: border-box;
    border-style: solid;
    border-width: 0 0 1px 0;
    border-color: #f1f1f1;
    background-color: #ffffff;
    height: 189px;
    margin-bottom: 36px;
    .goods-head-form {
      padding-top: 1rem;
      display: flex;
      .fileds {
        flex: 0 1 75%;
        /deep/ .el-form-item {
          label:after {
            content: " : ";
          }
          .el-input {
            width: 217px;
          }
        }
      }
      .buttons {
        flex: 0 1 25%;
        display: inherit;
        align-items: center;
        justify-content: center;
      }
    }
  }

  .goods-data {
    .goods-data-header {
      color: $main-color;
      font-weight: bold;
      background-color: #ffffff;
      height: 51px;
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.09);
      border-radius: 4px;
      ul {
        display: flex;
        flex-wrap: nowrap;
        line-height: 51px;
        box-sizing: content-box;
        li {
          font-size: 14px;
          min-width: 50px;
          margin: auto auto;
          text-align: center;
          &:first-child {
            flex-basis: 20%;
          }
          &:nth-child(2) {
            flex-basis: 15%;
          }
          &:nth-child(3) {
            flex-basis: 15%;
          }
          &:nth-child(4) {
            flex-basis: 15%;
          }
          &:nth-child(5) {
            flex-basis: 15%;
          }
          &:last-child {
            flex-basis: 180px !important;
          }
        }
      }
    }

    .goods-data-body {
      position: relative;
      min-height: 420px;
      .no-data-info {
        background-color: #fff;
        width: 100%;
        text-align: center;
        margin-top: 8px;
        height: 48px;
        line-height: 48px;
        font-size: 15px;
      }
      .data-item {
        // height: 83px;
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.09);
        border-radius: 4px;
        margin: 8px 0px;
        // border: 1px solid #ebeef5;
        position: relative;
        box-sizing: border-box;

        ul {
          display: flex;
          flex-wrap: nowrap;
          width: 100%;
          min-height: 83px;
          // height: 83px;
          position: relative;
          background-color: white;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);

          *::selection {
            background-color: rgba(0, 0, 0, 0) !important;
          }
          li {
            font-size: 15px;
            min-width: 50px;
            // height: 100%;
            // display: flex;
            // align-items: center;
            // justify-content:center;
            margin: auto auto;
            padding: 0px 4px;

            text-align: center;
            position: relative;
            &:first-child {
              flex-basis: 20%;
            }
            &:nth-child(2) {
              flex-basis: 15%;
            }
            &:nth-child(3) {
              flex-basis: 15%;
            }
            &:nth-child(4) {
              flex-basis: 15%;
            }
            &:nth-child(5) {
              flex-basis: 15%;
            }
            &:last-child {
              flex-basis: 180px !important;
              .el-button:first-child {
                color: #be2316 !important;
              }
              .el-button:nth-child(3) {
                color: #e6a23c !important;
              }
              /deep/ .el-button.is-plain {
                background-color: white;
                color: #be2316;
                border-color: #be2316;
                padding: 7px 4px !important;
                width: 56px;
                span > i {
                  transition: 0.5s all;
                  transform: rotateZ(90deg);
                  &.expand {
                    transform: rotateZ(-90deg);
                  }
                }
              }
            }
          }
        }
        /deep/ .goods-item-details {
          border: 1px solid #ebeef5;
          z-index: 0;
        }
      }
    }
    .goods-data-pagination {
      margin-top: 24px;
      padding: 16px 0px;
      background-color: white;
    }
  }

  .recommend-dialog-head {
    box-sizing: border-box;
    border-style: solid;
    border-width: 0 0 1px 0;
    border-color: #f1f1f1;
    background-color: #ffffff;
    .slider-list {
      display: block;
      margin: 0 0;
      height: 36px;
      overflow: auto;
      white-space: nowrap;
      border-bottom: 1px solid #f1f1f1;
      &::-webkit-scrollbar {
        height: 0px !important;
        width: 0px !important;
      }
      &::-moz-scrollbar {
        height: 0px !important;
        width: 0px !important;
      }
      .item {
        // height: 35px;
        height: calc(100% - 1px);
        display: inline-block;
        width: 100px;
        font-size: 16px;
        font-weight: 600;
        line-height: 35px;
        margin-right: 12px;
        border-bottom: 1px solid rgba(0, 0, 0, 0);
        text-align: center;
        transition: all 1s;
        color: black;
        cursor: pointer;

        &.selected {
          border-bottom: 1px solid $main-color;
          transition: all 1s;
          color: $main-color;
        }
      }
    }
    .goods-head-form {
      padding-top: 1rem;
      display: flex;
      .fileds {
        flex: 0 1 75%;
        /deep/ .el-form-item {
          label:after {
            content: " : ";
          }
        }
      }
      .buttons {
        flex: 0 1 25%;
        display: inherit;
        align-items: center;
        justify-content: center;
      }
    }
  }
}
</style>

